import api from "./api";
import isEqual from "lodash/isEqual";
import { getClientData } from "../components/custom";
import { logout } from "./authService";

let lastUserFetchTime = 0;
const INTERVAL = 3000;

export async function fetchUserIfNeeded() {
    const now = Date.now();

    if (now - lastUserFetchTime < INTERVAL) return;

    lastUserFetchTime = now;

    try {
        const res = await api.post("/current-user-details", {
            skipUserCheck: true,
        });
        const latestUser = res?.data?.data?.[0];

        const localUser = getClientData();

        if (latestUser?.is_active === "0") {
            await logout();
            return;
        }

        if (!isEqual(latestUser, localUser)) {
            localStorage.setItem(
                "user_data",
                btoa(JSON.stringify({ client: [latestUser] }))
            );
            // window.location.reload();
        }
    } catch (err) {
        console.error("User fetch error:", err);
    }
}